module.exports = __webpack_public_path__ + "img/closed-loop-11.69ae3161.png";